import { AppMainComponent } from './../../../../../app.main.component';
import { ActivityCount } from './../../../models/activity-count.model';
import { ParseHelper } from 'src/app/modules/shared/parse.helper';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MessageService } from "primeng/api";
import { AppMainService } from 'src/app/app-main.service';
import { CalendarEventService, TaskService } from 'src/app/shared/api/api';
import { LionSharedEmailsComponent } from '../../shared-emails/shared-emails.component';
import { ActivityService } from "./../activity.service";
import { LogService, NoteService } from "./../api/api";
import { ObjectNames } from '../../../constants/object.names';
import { AccountModuleId, CaseModuleId, InvoiceOrderModuleId, LeadModuleId, OpportunityModuleId } from '../../../constants/modules.constant';
import { Subject, map, switchMap, takeUntil } from 'rxjs';
import { StageWiseActivities } from '../../../models/stage-wise-activities.model';
import { ActivityDataService } from '../activity-data.service';
import { ACTIVITY_ICON_COLOR_LIST } from '../../../constants/activity-icon-color-list.constants';
import { environment } from 'src/environments/environment';
import { lowercaseFirstLetter } from '../../../helpers/lowercase-first-letter.helper';
import { ReadActivitiesByIdsPayload, ReadUnreadActivityStatusPayload } from '../../../models/activity-list-payload.model';
import { AccountServiceN } from 'src/app/accounts-v2/services/account.services';

@Component({
    selector: "app-shared-activities-timeline",
    templateUrl: "./shared-activities-timeline.component.html",
    styleUrls: ["./shared-activities-timeline.component.scss"],
    providers: [
        LogService,
        NoteService,
        ActivityService,
        CalendarEventService,
        TaskService,
    ],
})
export class SharedActivitiesTimelineComponent implements OnInit, OnChanges, OnDestroy {

    @Input() hideRigthArrow: boolean = false;
    @Input() hideMenuBar: boolean = false;
    @Input() channelId: number;
    @Input() currentStageId: number;
    @Input() objectId: number;
    @Input() objectTypeId: number;
    @Input() selectedObject: any;
    @Input() objectType: string = "";
    @Input() contacts;
    @Input() selectedObjectStages = [];
    @Input() isViewMode = false;
    @Input() fromAccountView = false;
    @Input() hideEmailSyncIcon: boolean = true;
    @Input() showActivityLoader: boolean = true;
    @Input() isLogOnly: boolean = false;;

    @Output() object = new EventEmitter();
    @Output() taskAdded = new EventEmitter<any>();
    @Output() selectedAccountId = new EventEmitter<number>();

    @ViewChild(LionSharedEmailsComponent) lionSharedEmailsComponent: LionSharedEmailsComponent;


    private ngUnsubscribe$: Subject<any> = new Subject<void>();
    activityCallTrigger$ = new Subject<any>(); // To trigger API call
    activityLogTimelines: StageWiseActivities[] = [];

    caseModuleId = CaseModuleId

    loadingActivityLogs: boolean = false;
    showSpinner: boolean = false;
    displayAllActivityLists = false;
    displaySendEmail: boolean = false;
    displayAddLog: boolean = false;
    timelineExpanded: boolean = false;
    showEvent: boolean = false;

    filters = {
        ALL_ACTIVITY: null,
        USER_ACTIVITY: 'user_activity',
        SYSTEM_ACTIVITY: 'system_activity',
        FAVORITE: 'favorite_activity'
    };
    filterType: string = 'default_activity';
    expandCollapseText: string = 'Expand All';

    emailSyncTooltip: string = `Email Sync is running...
                        More than 10 Email will sync in background which may take some times.
                        You can refresh to see the latest`;

    activeButton: 'Email' | 'Log' = 'Log';
    assestBaseUrl: string = environment.assestsBasePath;

    showTaskTable = false;

    constructor(
        private app: AppMainComponent,
        private activityService: ActivityService,
        private activityDataService: ActivityDataService,
        private messageService: MessageService,
        private accountServiceN: AccountServiceN,
    ) {
        this.initiateApiCall();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes?.hideEmailSyncIcon?.currentValue) {
            this.hideEmailSyncIcon = changes.hideEmailSyncIcon.currentValue;
        }

        if (changes?.channelId && changes?.channelId?.currentValue) {
            this.channelId = changes?.channelId?.currentValue;
        }

        if (changes && changes.selectedObject && changes.selectedObject.currentValue) {
            this.selectedObject = changes.selectedObject.currentValue;
            this.channelId = this.selectedObject?.typeId || this.selectedObject?.channelId || this.selectedObject?.pipelineId || this.channelId;
            this.currentStageId = this.selectedObject?.stageId || this.selectedObject?.leadStageId || this.selectedObject?.businessClassificationId || this.selectedObject?.opportunityStageId || this.currentStageId;
        }

        if (changes && changes.selectedObjectStages && changes.selectedObjectStages.currentValue) {
            this.selectedObjectStages = changes.selectedObjectStages.currentValue;
        }

        if (changes && changes.objectTypeId && changes.objectTypeId.currentValue) {
            this.objectTypeId = changes.objectTypeId.currentValue;
        }

        if (changes && changes.objectType && changes.objectType.currentValue) {
            this.objectType = changes.objectType.currentValue;
            this.setObjectType();
        }

        if (changes?.isViewMode?.currentValue) {
            this.isViewMode = changes.isViewMode.currentValue;
        }

        if (changes && changes.objectId && changes.objectId.currentValue) {
            this.objectId = changes.objectId.currentValue;
            this.getActivityTimeline();
        }
    }

    ngOnInit(): void {
        if (this.objectType) {
            this.setObjectType();
        }

        this.activityDataService.getData().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(data => {
            if (data?.reload) {
                this.getActivityTimeline();
            }
        });
    }

    setObjectType() {
        switch (this.objectType) {
            case ObjectNames.LEAD:
                this.objectTypeId = LeadModuleId;
                break;
            case ObjectNames.ACCOUNT:
                this.objectTypeId = AccountModuleId;
                break;
            case ObjectNames.OPPORTUNITY:
                this.objectTypeId = OpportunityModuleId;
                break;
            case ObjectNames.CASES:
                this.objectTypeId = CaseModuleId;
            break;
        }
    }

    initiateApiCall() {
        this.activityCallTrigger$
            .pipe(
                switchMap(({ objectTypeId, channelId, currentStageId, objectId, filterType, activeButton, refreshWithoutLoading, stageDetails }) =>
                    this.activityService.stageWiseActivities(objectTypeId, channelId, currentStageId, objectId, filterType, activeButton)
                        .pipe(map(response => ({ response, refreshWithoutLoading, stageDetails })))
                ),
                takeUntil(this.ngUnsubscribe$)
            )
            .subscribe({
                next: ({ response, refreshWithoutLoading, stageDetails }) => {
                    if (!refreshWithoutLoading) {
                        this.timelineExpanded = true;
                    }
                    this.loadingActivityLogs = false;
                    this.activityLogTimelines = response;
                    //this.readActivityStatus(this.objectTypeId, this.objectId);

                    if (this.activityLogTimelines?.length > 0 && !refreshWithoutLoading) {
                        this.activityLogTimelines[0]['expanded'] = true;
                        this.readActivities(this.activityLogTimelines[0]?.activities||[]);
                        this.expandCollapseText = 'Collapse All';
                        this.filterType = this.activityLogTimelines[0]?.filterType || null;
                    }
                    this.generateActvityCounts(stageDetails, refreshWithoutLoading);
                },
                error: (error) => {
                    this.loadingActivityLogs = false;
                }
            });
    }

    getActivityTimeline(filterType: string = 'default_activity', stageDetails: any = null, refreshWithoutLoading: boolean = false) {
        if (this.objectId && this.objectTypeId) {
            if (!refreshWithoutLoading) {
                this.loadingActivityLogs = true;
            }
            this.activityCallTrigger$.next({
                objectTypeId: this.objectTypeId,
                channelId: this.channelId,
                currentStageId: this.currentStageId,
                objectId: this.objectId,
                filterType: filterType,
                activeButton: this.activeButton,
                refreshWithoutLoading: refreshWithoutLoading,
                stageDetails: stageDetails
            });
        }
    }

    generateActvityCounts(selectedStageDetails, refreshWithoutLoading: boolean = false) {
        this.activityLogTimelines.filter(a => a.activities?.length > 0).map(stageDetails => {
            const activityCounts: ActivityCount[] = ParseHelper.DeepCopy(ACTIVITY_ICON_COLOR_LIST);
            activityCounts.map(activityGroup => {
                stageDetails.activities.map(activity => {

                    if (activity?.objectData?.activityFeedPayload?.payload && typeof activity?.objectData?.activityFeedPayload?.payload == 'string') {
                        activity.payloadDetails = JSON.parse(activity.objectData.activityFeedPayload?.payload);
                        activity.payloadDetails = lowercaseFirstLetter(activity.payloadDetails);
                    }

                    if (activityGroup.activityNames.includes(activity?.activityName)
                        && ((activityGroup.types == null && !activity.type) || (activityGroup.types !== null && (activityGroup.types.length == 0 || activityGroup.types.includes(activity.type))))
                        && (activityGroup.subTypes.length == 0 || activityGroup.subTypes.includes(activity.subType))) {
                        activity['activityGroup'] = activityGroup;
                    }
                });

                activityGroup.counts = stageDetails.activities.filter(activity => (activityGroup.activityNames.includes(activity?.activityName)
                    && ((activityGroup.types == null && !activity.type) || (activityGroup.types !== null && (activityGroup.types.length == 0 || activityGroup.types.includes(activity.type))))
                    && (activityGroup.subTypes.length == 0 || activityGroup.subTypes.includes(activity.subType))))?.length || 0;
            });
            stageDetails.allActivities = stageDetails.activities;
            stageDetails['activityCounts'] = activityCounts.filter(a => a.counts > 0);
            if (refreshWithoutLoading && selectedStageDetails?.stageId == stageDetails?.stageId) {
                stageDetails['expanded'] = true;
            }
        });
    }

    filterActivitiesByCount(stageDetails: StageWiseActivities, countDetails: ActivityCount) {
        stageDetails['expanded'] = true;
        if (stageDetails?.filteredCounts?.id == countDetails.id) {
            stageDetails.filteredCounts = null;
            stageDetails.activities = stageDetails.allActivities;
        } else {
            stageDetails.filteredCounts = countDetails;
            stageDetails.activities = stageDetails.allActivities.filter(a => a?.activityGroup?.id == countDetails?.id);
        }
    }

    filterActivities(filterType) {
        this.filterType = filterType;
        this.getActivityTimeline(this.filterType);
    }

    populateDraftCount() {
        this.displaySendEmail = true;
        this.lionSharedEmailsComponent.populateDraftCount();
    }

    openAllActivityList() {
        this.displayAllActivityLists = true;
    }

    closeActivityDialog() {
        this.displayAllActivityLists = false;
    }

    cancelEmail(event) {
        this.displaySendEmail = event.cancelEmail;
    }

    openLogs() {
        if(this.objectType == 'Account'){
          this.accountServiceN.getUserAccessList(this.objectId);
        }
        this.app.objectId = this.objectId;
        this.app.objectType = this.objectType;
        this.app.objectTypeId = this.objectTypeId;
        this.displayAddLog = true;
    }

    cancelLog(event) {
        this.displayAddLog = event.cancelEmail;
    }

    newTaskAdded() {
        this.taskAdded.emit({ "taskAdded": true });
    }

    emailSync(emailAuditId: number = 0) {
        this.showSpinner = true;
        this.activityService.getEmailSync(this.objectId, this.objectTypeId, emailAuditId).subscribe(
            {
                next: (res) => {
                    this.showSpinner = false;
                    this.getActivityTimeline();
                },
                error: (error) => {
                    this.showSpinner = false;
                }
            });
    }

    syncSendEmail(mailObj: any) {
        this.loadingActivityLogs = true;
        setTimeout(() => {
            this.emailSync(mailObj?.emailAudit?.id ?? mailObj?.emailAuditId ?? 0);
            this.loadingActivityLogs = false;
        }, 2000);
    }

    toogleTimelineActivity(stageDetails: any) {
        stageDetails['expanded'] = !stageDetails?.expanded;
        this.readActivities(stageDetails?.activities||[]);
    }

    expanAllActivities() {
        this.timelineExpanded = !this.timelineExpanded;
        if (this.timelineExpanded) {
            this.expandCollapseText = 'Collapse All';
        } else {
            this.expandCollapseText = 'Expand All';
        }

        const allActivities = [];
        this.activityLogTimelines.map(stageDetails => {
            stageDetails['expanded'] = this.timelineExpanded;
            allActivities.push(...stageDetails?.activities);
        });

        if(this.timelineExpanded){
            this.readActivities(allActivities||[]);
        }
    }

    setActive(buttonName) {
        this.activeButton = buttonName;
        if (buttonName == 'Task') {
            this.showEvent = false;
            this.showTaskTable = true;
        } else if (buttonName == 'Event') {
            this.populateEventDetails();
        }
        else {
            this.showEvent = false;
            this.showTaskTable = false;
            this.getActivityTimeline();
        }


    }

    populateEventDetails() {
        this.showEvent = true;
        this.showTaskTable = false;
        this.displayAddLog = false;
        this.displaySendEmail = false;
    }

    readActivityStatus(activityId: number, objectRecordId: number) {
        const readActivityStatus: ReadUnreadActivityStatusPayload = {
            objectId: activityId,
            objectRecordId: objectRecordId,
            isRead: true
        }
        this.activityService.readUnreadActivityStatus(readActivityStatus)
            .subscribe({
                next: () => {
                    this.selectedAccountId.emit(objectRecordId);
                },
                error: (error) => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error?.error?.Message ?? 'Error updating activity status'
                    });
                }
            });;
    }

    readActivities(activities: any[]){
        const unreadActivities: ReadActivitiesByIdsPayload[] = activities.filter(activity=> activity.isRead===false).map(activity=>{
            return {
                objectId: activity?.moduleData?.objectId||this.objectTypeId,
                objectRecordId: activity?.moduleData?.objectRecordId||this.objectId,
                logType: activity.activityName,
                logId: activity?.activityId
            }
        });
        if(unreadActivities?.length>0){
            this.activityService.readActivitiesByIds(unreadActivities)
            .subscribe({
                next: () => {
                    this.selectedAccountId.emit(this.objectId);
                },
                error: (error) => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error?.error?.Message ?? 'Error updating activity status'
                    });
                }
            });;
        }
    }


    ngOnDestroy() {
        this.ngUnsubscribe$?.next(null);
        this.ngUnsubscribe$?.complete();
    }
}
